import React from 'react';
import { Star, MapPin } from 'lucide-react';
import { testimonials } from '../mockData';

const Testimonials = () => {
  return (
    <div className="min-h-screen bg-black pt-24">
      <section className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              <span className="text-gradient-gold">Müşteri Yorumları</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              İzmir'deki memnun müşterilerimizin görüşleri
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card space-y-4">
                <div className="flex items-center justify-between">
                  <div className="rating-stars">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-current" />
                    ))}
                  </div>
                  <span className="text-xs text-gray-500">
                    {new Date(testimonial.date).toLocaleDateString('tr-TR')}
                  </span>
                </div>
                
                <p className="text-gray-300 leading-relaxed italic">
                  "{testimonial.comment}"
                </p>

                <div className="pt-4 border-t border-zinc-800 space-y-2">
                  <p className="font-semibold text-white text-lg">{testimonial.name}</p>
                  <div className="flex items-center text-sm text-gray-500">
                    <MapPin className="w-3 h-3 mr-1" />
                    {testimonial.location}
                  </div>
                  <div className="inline-block px-3 py-1 bg-yellow-500/10 border border-yellow-500/30 rounded-full">
                    <p className="text-xs text-yellow-500 font-medium">{testimonial.service}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-gradient-to-r from-zinc-900 to-zinc-800 rounded-2xl p-8 md:p-12 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Siz de <span className="text-gradient-gold">Memnun Müşterilerimize</span> Katılın
            </h2>
            <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
              Profesyonel hizmet anlayışımız ve kaliteli işçiliğimizle sizin de memnuniyetinizi garanti ediyoruz.
            </p>
            <div className="flex items-center justify-center gap-8 flex-wrap">
              <div className="text-center">
                <p className="text-4xl font-bold text-yellow-500">100+</p>
                <p className="text-sm text-gray-400">Mutlu Müşteri</p>
              </div>
              <div className="text-center">
                <p className="text-4xl font-bold text-yellow-500">5.0</p>
                <p className="text-sm text-gray-400">Ortalama Puan</p>
              </div>
              <div className="text-center">
                <p className="text-4xl font-bold text-yellow-500">%98</p>
                <p className="text-sm text-gray-400">Memnuniyet Oranı</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
